import {
  isRomanticStyle,
  toneVariant,
  useCompanionNoun,
} from '@/utils/personalization'
import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import type { AnswerType } from '@app-studio-web/ui/types'

const baseAnswers: AnswerType[] = [
  {
    emoji: '🤗',
    title: 'pages.onboarding.personality.nurturing',
    value: 'nurturing',
  },
  {
    emoji: '😏',
    title: 'pages.onboarding.personality.playful',
    value: 'playful',
  },
  { emoji: '🧘', title: 'pages.onboarding.personality.wise', value: 'wise' },
  {
    emoji: '⚡',
    title: 'pages.onboarding.personality.energetic',
    value: 'energetic',
  },
  {
    emoji: '🌙',
    title: 'pages.onboarding.personality.intuitive',
    value: 'intuitive',
  },
]

const romanticAnswers: AnswerType[] = [
  {
    emoji: '🥰',
    title: 'pages.onboarding.personality.romantic.nurturing',
    value: 'nurturing',
  },
  {
    emoji: '😏',
    title: 'pages.onboarding.personality.romantic.playful',
    value: 'playful',
  },
  {
    emoji: '🌿',
    title: 'pages.onboarding.personality.romantic.wise',
    value: 'wise',
  },
  {
    emoji: '🔥',
    title: 'pages.onboarding.personality.romantic.energetic',
    value: 'energetic',
  },
  {
    emoji: '🌙',
    title: 'pages.onboarding.personality.romantic.intuitive',
    value: 'intuitive',
  },
]

export default function PersonalityQuestionPage() {
  const noun = useCompanionNoun()
  const romantic = isRomanticStyle()

  return (
    <SingleChoiceQuestionPage
      answers={romantic ? romanticAnswers : baseAnswers}
      title={
        romantic
          ? 'pages.onboarding.personality.title_romantic'
          : 'pages.onboarding.personality.title_friend'
      }
      subtitle={toneVariant('pages.onboarding.personality.subtitle')}
      translationInterpolation={{ noun }}
    />
  )
}
